/** 统一日期格式化（时间戳 ms → 本地日期时间字符串） */
export function formatDate(value: number | string | undefined | null): string {
  if (value == null || value === '') {
    return '';
  }
  if (typeof value === 'number') {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) {
      return String(value);
    }
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
  return value;
}

/** 仅日期部分 YYYY-MM-DD */
export function formatDateOnly(value: number | string | undefined | null): string {
  const formatted = formatDate(value);
  if (!formatted) return '';
  return formatted.split(' ')[0] ?? formatted;
}
